/**************************************************
 * Nombre:       Formulario_Pqrs
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {
    AccountCircleOutlined,
    BadgeOutlined,
    FlagOutlined,
    MailOutline,
    PhoneAndroidOutlined
} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {TIPOSPQRS} from "../../Constantes";

const Formulario_Pqrs = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre Completo'} dato={'nombre'} {...props}
                                  requerido={'Dato Requerido'}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props}
                                  requerido={'Dato Requerido'}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Num Celular'} dato={'celular'} {...props}
                                  requerido={'Dato Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo electronico'} dato={'correo'} {...props}
                                  requerido={'Dato Requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo'} dato={'tipo'} {...props}
                                   requerido={'Dato Requerido'} opciones={TIPOSPQRS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Asunto'} dato={'asunto'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={8} nombre={'Mensaje'} dato={'mensaje'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pqrs